module.exports = __webpack_public_path__ + "img/1949-Martinsville Seven-cropped.929c0027.jpg";